import { PRODUCTS } from 'lib/constants/routes';
import { useRouter } from 'next/router';

export const useIsPdp = () => {
  const router = useRouter();
  return router.route.includes(PRODUCTS);
};
